import React,{useEffect,useState} from 'react';
import 'leaflet/dist/leaflet.css';
import './PopupINV.css';

const PopupPR = (props) => {

    const { nombre, idCT, idINV, pr, status } = props;

    var link = "/#/inv/" + idCT + "/" + idINV;

    //Deshabilitar el link si no hay pantalla de inversor
    const screen = JSON.parse(sessionStorage.getItem('ScreenConfiguration')).filter(screen => screen.Screen === "Inverter");
    const [hrefDisabled,setHrefDisabled] = useState(<></>);

    useEffect(() => {
        if(screen[0].Enabled === false){
            setHrefDisabled(<a className='a-ver-inv' style={{cursor:'none'}}>{nombre}</a>)
        }else{
            setHrefDisabled(<a className='a-ver-inv' href={link}>{nombre}</a>)
        }
    },[]);

    return (
        <div className='container-fluid' style={{width: 'fit-content', padding: '0px'}}>
            <div className='row justify-content-center'>
                <div className='col-auto'>
                    {hrefDisabled}
                </div>
            </div>
            <div className='row' style={{margin: '5px'}}>
                <div className='col-auto'>Rango: <strong>{status}</strong></div>
            </div>
            <div className='row' style={{margin: '5px'}}>
                <div className='col-auto'>PR: <strong>{pr}</strong></div>
            </div>
        </div>
    );
};

export default PopupPR;